export { fallback as default } from '../lib/middleware/fallback.js';
